import { fetchAPI } from "./utils";

export interface ActivityPCVTypeLocalized {
    id: string;
    language: string;
    name: string;
}

export interface ActivityPCVType {
    id: string;
    position: number;
    name: string;
    activityCount: number;
    activityPCVTypeLocalized?: ActivityPCVTypeLocalized[];
}

/**
 * Resolve a type's display name for the given UI language, falling back to EN
 * and then to any available localized row (or the server-provided `name`).
 */
export const resolveTypeName = (type: ActivityPCVType, language?: string): string => {
    const localized = type.activityPCVTypeLocalized;
    if (!localized || localized.length === 0) return type.name || "";
    const code = (language || "EN").toUpperCase();
    const match = localized.find((l) => l.language?.toUpperCase() === code);
    const en = localized.find((l) => l.language?.toUpperCase() === "EN");
    return (match || en || localized[0])?.name || type.name || "";
};

export const getActivityPCVTypes = async ({ token }: { token: string }): Promise<ActivityPCVType[]> => {
    return fetchAPI<ActivityPCVType[]>("/get-activity-pcv-types", "GET", undefined, token);
};

export const createActivityPCVType = async ({
    token,
    name,
    language,
}: {
    token: string;
    name: string;
    language: string;
}): Promise<{ message: string; type: { id: string } }> => {
    return fetchAPI<{ message: string; type: { id: string } }>(
        "/create-activity-pcv-type",
        "POST",
        { name, language },
        token,
    );
};

export const updateActivityPCVType = async ({
    token,
    typeId,
    newName,
    language,
    position,
}: {
    token: string;
    typeId: string;
    newName?: string;
    language?: string;
    position?: number;
}): Promise<{ message: string }> => {
    return fetchAPI<{ message: string }>(
        "/update-activity-pcv-type",
        "POST",
        { typeId, newName, language, position },
        token,
    );
};

export const deleteActivityPCVType = async ({
    token,
    typeId,
}: {
    token: string;
    typeId: string;
}): Promise<{ message: string }> => {
    return fetchAPI<{ message: string }>("/delete-activity-pcv-type", "POST", { typeId }, token);
};

export const reorderActivityPCVTypes = async ({
    token,
    orderedIds,
}: {
    token: string;
    orderedIds: string[];
}): Promise<{ message: string }> => {
    return fetchAPI<{ message: string }>("/reorder-activity-pcv-types", "POST", { orderedIds }, token);
};
